import app from '@/app';
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

app.config.globalProperties.$dayjs = dayjs
